/* Shop4Seats — free material samples popup (snippets/samples-modal, product pages only).
 * Opened by theme.js' generic [data-modal-open="SamplesModal"]. Each ticked colour becomes its own $0 cart line
 * (its colour variant of the samples product, or "Default"), with properties "Sample for" (this product) and
 * "_fill" (swatch colour, cart fallback image). Colours already in the cart for this product are shown as
 * "In cart" and cannot be added twice. On success: close the popup, open the cart drawer. */
(() => {
  const box = document.querySelector('[data-samples]');
  if (!box || box._init) return;
  box._init = true;
  const S4S = window.S4S || {};
  const submit = box.querySelector('[data-samples-submit]');
  const err = box.querySelector('.samples__error');
  const inputs = () => [...box.querySelectorAll('input[type="checkbox"]')];
  const forTitle = box.dataset.for;

  const sync = () => { submit.disabled = !inputs().some((i) => i.checked && !i.disabled); };
  box.addEventListener('change', sync);

  // Mark colours already in the cart (same product + colour) when the popup opens
  const markInCart = async () => {
    try {
      const cart = await fetch(`${(S4S.routes && S4S.routes.cart) || '/cart'}.js`).then((r) => r.json());
      const have = new Set(cart.items
        .filter((it) => it.properties && it.properties['Sample for'] === forTitle)
        .map((it) => it.properties.Color || it.variant_title));
      inputs().forEach((i) => {
        const inCart = have.has(i.value);
        i.disabled = inCart;
        if (inCart) i.checked = false;
        i.closest('.samples__item').querySelector('.samples__badge').hidden = !inCart;
      });
      sync();
    } catch (e) { /* offline: leave everything selectable */ }
  };
  new MutationObserver(() => { if (!box.hidden) { err.hidden = true; markInCart(); } }).observe(box, { attributes: true, attributeFilter: ['hidden'] });

  submit.addEventListener('click', async () => {
    const picked = inputs().filter((i) => i.checked && !i.disabled);
    if (!picked.length || !S4S.cart) return;
    err.hidden = true;
    S4S.busy && S4S.busy(submit, true);
    const items = picked.map((i) => ({
      id: Number(i.dataset.vid),
      quantity: 1,
      // Default variant: the colour travels as a visible "Color" property; a colour variant's title already says it
      properties: 'default' in i.dataset ? { Color: i.value, 'Sample for': forTitle, _fill: i.dataset.fill || '' } : { 'Sample for': forTitle, _fill: i.dataset.fill || '' },
    }));
    try {
      await S4S.cart.add(items);
      picked.forEach((i) => { i.checked = false; });
      box.querySelector('[data-modal-close]').click();
      S4S.cart.open();
    } catch (e) {
      err.textContent = (e && e.message) || 'Samples could not be added. Please try again.';
      err.hidden = false;
    } finally {
      S4S.busy && S4S.busy(submit, false);
      sync();
    }
  });
})();
